import React from 'react'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'
import isEmpty from 'lodash/isEmpty'
import { action, observable, toJS } from 'mobx'
import { Button, Row, Col, Modal } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import {
  subscriptionContainer,
  customerContainer,
  addressContainer,
  cartContainer,
} from 'src/models'
import { dateFormatDeps } from 'src/deps'
import { getTotalPagesForPagination, capitalizeFirstLetter } from 'src/utils'
import {
  Icons,
  PaymentIcon,
  overlayState,
  toastState,
} from 'src/views/components'
import EditUpdatePaymentModal from 'src/views/pages/MyAccount/Payments/EditUpdatePaymentModal'
import { ShippingDetailsCard } from './ShippingDetailsCard'
import ShippingEditingModal from './ShippingEditingModal'
import CreditCardExpiryInfo from './CreditCardExpiryInfo'

@observer
class ShippingPayment extends React.Component {
  @observable isEditPayments = false
  @observable enablePaymentModal = false
  @observable isPaymentCallInProgress = false
  @observable showEditPaymentModal = false
  @observable showDeleteConfirmationModal = false
  @observable IDofCardToBeEdited = ''
  @observable selectedCardData = {}
  isCardExpiringSoon = false
  isCardExpired = false
  totalPagesLength = 0
  subscriptionPaymentId = ''
  @action
  async componentDidMount() {
    await customerContainer.getPaymentsForDashboard()
    subscriptionContainer.ccExpiryFlag =
      this.isCardExpiringSoon || this.isCardExpired
    subscriptionContainer.ccCardExpired = this.isCardExpired
  }
  componentDidUpdate(prevProps) {
    const { pageableInfo = {} } = customerContainer.paymentsForDashboard || {}
    this.totalPagesLength = getTotalPagesForPagination(pageableInfo)
    subscriptionContainer.ccExpiryFlag =
      this.isCardExpiringSoon || this.isCardExpired
    subscriptionContainer.ccCardExpired = this.isCardExpired
  }
  toggleEditSubscriptionValue = (e, id = 0) => {
    this.showEditSubscriptionModal = !this.showEditSubscriptionModal
    this.IDofCardToBeEdited = id
  }
  renderPaymentDetails = () => {
    const title = i18nTranslate('subscription.paymentTitle', 'Payment Method')
    const { payment = {} } =
      subscriptionContainer.subscriptionPreferenceResponse
    const {
      cardNumber = '',
      cardExpirationMonth = '',
      cardExpirationYear = '',
      expiryMonth = '',
      expiryYear = '',
      cardType = '',
    } = payment
    const daysInExpirationMonth = dayjs(
      `${parseInt(cardExpirationYear || expiryYear)}-${parseInt(
        cardExpirationMonth || expiryMonth
      )}-01`
    ).daysInMonth()

    const cardExpirationDate = dayjs(
      `${parseInt(cardExpirationYear || expiryYear)}-${parseInt(
        cardExpirationMonth || expiryMonth
      )}-${daysInExpirationMonth}`
    )

    const daysLeftForExpiry = cardExpirationDate.diff(
      dayjs().format('YYYY-MM-DD'),
      'day'
    )
    this.isCardExpiringSoon = daysLeftForExpiry <= 60 && daysLeftForExpiry >= 0
    this.isCardExpired = daysLeftForExpiry < 0
    this.subscriptionPaymentId = payment?.id || ''
    const name =
      payment?.firstName && payment?.lastName
        ? `${payment.firstName} ${
            payment.firstName !== payment.lastName ? payment.lastName : ''
          }`
        : ''
    const endingText = '****'
    const expiryText = i18nTranslate('payment.cardExp', 'Exp.')
    const expiredText = i18nTranslate(
      'payment.cardExpiredText',
      'Card is Expired'
    )
    const cardName =
      cardNumber && cardExpirationMonth && cardExpirationYear
        ? `${endingText} ${cardNumber}, ${
            this.isCardExpired ? expiredText : expiryText
          } ${cardExpirationMonth}/${String(cardExpirationYear)?.substr(2)}`
        : ''
    return (
      <div className="" data-testid="payment-container">
        <ShippingDetailsCard
          details={{
            heading: title,
            // line1: cardType,
            line2: name,
            line3: `${cardType} ${cardName}`,
            cardType: cardType,
            isFrom: 'payment',
            event: this.handleEditPayment,
          }}
        />
      </div>
    )
  }
  handleEditPayment = () => {
    this.isEditPayments = true
  }

  renderShippingAddress = (address = {}, isFromModal = false) => {
    const {
      addressLine1 = '',
      addressLine2 = '',
      street1 = '',
      street2 = '',
      city = '',
      state = '',
      zipCode = '',
      zip = '',
      // phone = '',
      country = '',
      properties,
      deliveryInstruction,
      firstName = '',
      lastName = '',
    } = address
    const actualZip = zipCode || zip
    return (
      <>
        <div
          className={` ${isFromModal ? 'd-flex' : 'shipping-section'} ${
            this.isEditShippingAddress ? '' : ' '
          }`}
          data-testid="qa-user-sub-shipping-address">
          {!isFromModal && (
            <Row
              noGutters
              className={
                'align-items-center justify-content-between shipping-title'
              }>
              <div className="shipping-title-inner d-flex justify-content-between">
                <div className="text-uppercase shipping-text heading-6">
                  {i18nTranslate(
                    'subscription.shippingTitle',
                    'Shipping Address'
                  )}
                </div>
                <div className="">
                  {this.disableShippingEdit === false && (
                    <Button
                      disabled={
                        this.disableShippingEdit ||
                        this.isShippingAddressCallInProgress ||
                        this.isShippingMethodCallInProgress
                      }
                      onClick={() => (this.isEditShippingAddress = true)}
                      className={'edit-button shadow-none p-0'}
                      data-testid="qa-user-sub-shipping-address-edit">
                      <Icons
                        name="CRUD"
                        icontype="edit"
                        width="20px"
                        customIcon={
                          i18nTranslate(
                            'subscriptions.editButtonText',
                            'Edit'
                          ) +
                          ' ' +
                          i18nTranslate(
                            'subscription.shippingTitle',
                            'Shipping Address'
                          ).toLowerCase()
                        }
                        alt={i18nTranslate(
                          'subscription.shippingAddressEditIcon',
                          'shipping address edit icon'
                        )}
                        ariaLabel={i18nTranslate(
                          'subscription.shippingAddressEditIcon',
                          'shipping address edit icon'
                        )}
                      />
                    </Button>
                  )}
                </div>
              </div>
            </Row>
          )}
          {!isEmpty(address) ? (
            <p className="subscription-shipping-address paragraph-s pr-4">
              {firstName +
                `${firstName && ' '} ` +
                lastName +
                `${lastName && ','} ` +
                addressLine1 +
                `${addressLine1 && ','} ` +
                addressLine2 +
                `${addressLine2 && ','} ` +
                street1 +
                `${street1 && ','} ` +
                street2 +
                `${street2 && ','} ` +
                city +
                `${city && ','} ` +
                state +
                `${state && ','} ` +
                actualZip}
              <br />
              {country}
              <br />
              {deliveryInstruction && (
                <>
                  {i18nTranslate(
                    'shippingInstructions',
                    'Shipping instructions'
                  )}
                  {`: ${deliveryInstruction}`}
                </>
              )}
              {properties?.deliveryInstruction && (
                <>
                  <p className="shipping-text heading-6 m-0 pt-2">
                    {i18nTranslate(
                      'shippingInstructions',
                      'Shipping instructions'
                    )}
                    :
                  </p>
                  {properties?.deliveryInstruction}
                </>
              )}
              <br />
            </p>
          ) : (
            ''
          )}
          {isFromModal && !addressContainer.isRecommendationsVisible && (
            <p className="custom-alignment">
              <button
                tabIndex={0}
                onClick={() => this.handleSubscriptionAddressEdit(address)}
                className="custom-edit-link-button">
                {i18nTranslate('edit', 'Edit')}
              </button>
            </p>
          )}
        </div>
      </>
    )
  }
  checkIsDefaultPayment = (cardId = 0) => {
    return (
      cardId ===
      subscriptionContainer?.subscriptionPreferenceResponse?.payment?.id
    )
  }

  getCardData = async (id = '', activePage = 1) => {
    const response = await customerContainer?.getPaymentsForDashboard(
      false,
      activePage
    )

    const transformedResponse = customerContainer.transformPaymentResponse(
      response,
      activePage
    )
    return transformedResponse?.payments?.find(
      item => item?.id === id?.toString()
    )
  }

  toggleEditPaymentModal = async (id = '') => {
    const { pageableInfo = {} } = customerContainer.paymentsForDashboard || {}
    if (!this.showEditPaymentModal && id != '') {
      this.selectedCardData = await this.getCardData(id, pageableInfo?.page)
    }

    this.IDofCardToBeEdited = id?.toString()
    this.showEditPaymentModal = !this.showEditPaymentModal
  }

  toggleDeleteConfirmationModal = async (id = '') => {
    const { pageableInfo = {} } = customerContainer.paymentsForDashboard || {}
    this.selectedCardData = await this.getCardData(id, pageableInfo?.page)
    this.showDeleteConfirmationModal = !this.showDeleteConfirmationModal
  }

  renderPaymentMethod = (
    payment = {},
    isFromModal = false,
    isDefault = false
  ) => {
    const {
      name = '',
      firstName = '',
      lastName = '',
      cardExpirationYear = '',
      cardExpirationMonth = '',
      expiryYear = '',
      expiryMonth = '',
      type = '',
      displayName = '',
      provider = '',
      id = '',
    } = payment
    this.selectedDefaultCardId = id || ''
    const CC_EXPIRY_IN_MONTH = 1
    const cardNumber = (payment?.cardNumber || '').replace(
      /^(.{4})(.{4})(.{4})(.*)$/,
      '$1-$2-$3-$4'
    )
    const defaultSelectedMonth =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0
    const monthVal = location?.queryParams?.month || ''
    let selectedMonth = 0
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const lastOrderProcessedMonth =
      new Date(lastOrderProcessingDate).getMonth() + 1
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''

    if (subscriptionContainer.selectedMonth != '') {
      selectedMonth = subscriptionContainer.selectedMonth
    } else {
      selectedMonth = defaultSelectedMonth
    }
    const totalActiveSubscriptionCount =
      cartContainer.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount
    const accountNumber = payment?.properties?.accountNumber || ''
    const bankName = payment?.properties?.bankName || ''
    const endingDigits = accountNumber
      ? accountNumber.substr(accountNumber.length - 4)
      : undefined
    const currentDateTimeStamp = Date.now()
    const { month, year } =
      dateFormatDeps.convertTimeStampToDate(currentDateTimeStamp)
    const expiryText = i18nTranslate('payment.cardExpiresText', 'Expires')
    const expiredText = i18nTranslate(
      'payment.cardExpiredText',
      'Card is Expired'
    )

    const daysInExpirationMonth = dayjs(
      `${parseInt(cardExpirationYear || expiryYear)}-${parseInt(
        cardExpirationMonth || expiryMonth
      )}-01`
    ).daysInMonth()

    const cardExpirationDate = dayjs(
      `${parseInt(cardExpirationYear || expiryYear)}-${parseInt(
        cardExpirationMonth || expiryMonth
      )}-${daysInExpirationMonth}`
    )

    const daysLeftForExpiry = cardExpirationDate.diff(
      dayjs().format('YYYY-MM-DD'),
      'day'
    )
    this.isCardExpiringSoon = daysLeftForExpiry <= 60 && daysLeftForExpiry >= 0
    this.isCardExpired = daysLeftForExpiry < 0
    const expryTxt = this.isCardExpired ? expiryText : expiredText
    const endingText = '**'
    const cardFirstName = firstName || name
    if (!isDefault) {
      isDefault = this.checkIsDefaultPayment(payment?.id)
    }

    return (
      <>
        <Col
          className={`p-0 ${isFromModal ? '' : 'shipping-section'}`}
          data-testid="qa-user-sub-payment-method">
          {!isFromModal && (
            <Row
              noGutters
              className={
                'align-items-center justify-content-between shipping-title'
              }>
              {lastOrderProcessedMonth == selectedMonth &&
              (lastSubscriptionOrderStatus.toLowerCase() === 'payment_failed' ||
                lastSubscriptionOrderStatus.toLowerCase() === 'order_failed') &&
              totalActiveSubscriptionCount != 0 &&
              monthVal !== 'showall' ? (
                <div className="col-1 warningIcnDiv">
                  <Icons
                    name="product-icon"
                    icontype="danger-warning"
                    className="subscription-wrn-icon"
                    color="#8C6E43"
                  />
                </div>
              ) : (
                ''
              )}
              <div className="shipping-title-inner d-flex justify-content-between">
                <div className="text-uppercase shipping-text heading-6">
                  {i18nTranslate('subscription.paymentTitle', 'Payment Method')}
                </div>
                <div className="">
                  {this.disablePaymentEdit ? (
                    ''
                  ) : (
                    <Button
                      disabled={
                        this.disablePaymentEdit || this.isPaymentCallInProgress
                      }
                      onClick={() => (this.isEditPayments = true)}
                      className={'edit-button shadow-none p-0'}
                      data-testid="qa-user-sub-payment-method-edit">
                      <Icons
                        name="CRUD"
                        icontype="edit"
                        customIcon={
                          i18nTranslate(
                            'subscriptions.editButtonText',
                            'Edit'
                          ) +
                          ' ' +
                          i18nTranslate(
                            'subscription.paymentTitle',
                            'Payment Method'
                          ).toLowerCase()
                        }
                        width="20px"
                        alt={i18nTranslate(
                          'subscription.paymentMethodEditIcon',
                          'payment method edit icon'
                        )}
                        ariaLabel={i18nTranslate(
                          'subscription.paymentMethodEditIcon',
                          'payment method edit icon'
                        )}
                      />
                    </Button>
                  )}
                </div>
              </div>
            </Row>
          )}
          {!isEmpty(payment) ? (
            <>
              {type && type.toLowerCase() === 'ach' ? (
                <Col className="p-0 text-dark paragraph-s">
                  {i18nTranslate('subscription.achPayment', 'ACH')}
                  <br />
                  {bankName}
                  <br />
                  {endingDigits && (
                    <>{`${i18nTranslate(
                      'payment.accountEndingText',
                      'Account ending in'
                    )} - ${endingDigits}`}</>
                  )}
                </Col>
              ) : type && type.toLowerCase() === 'paypalsubscription' ? (
                <Col className="p-0 text-dark paragraph-s">
                  {i18nTranslate(
                    'subscription.paypalsubscription',
                    'PayPal Account'
                  )}
                  <br />
                  {displayName}
                </Col>
              ) : (
                type &&
                (type?.toLowerCase() === 'creditcard' ||
                  type?.toLowerCase() === 'debitcard') && (
                  <div className="p-0 text-dark paragraph-s m-0shipping-text ">
                    {name !== null && `${cardFirstName} `}
                    {cardFirstName !== lastName &&
                      lastName !== null &&
                      `${lastName} `}
                    {(cardFirstName !== null || lastName !== null) && <br />}
                    {!isFromModal ? (
                      <>
                        {endingText}
                        {cardNumber}
                        <br />
                      </>
                    ) : (
                      <span className="subscription-payment-details">
                        <PaymentIcon type={provider?.toLowerCase()} />
                        <span>{provider}</span>
                        <span>
                          {endingText}
                          {cardNumber}
                        </span>
                      </span>
                    )}
                    <span
                      data-testid="qa-expirydate"
                      className={`paragraph-m payment-card-expiry ${
                        this.isCardExpired ? 'payment-card-expired' : ''
                      } `}>
                      {`${this.isCardExpired ? expiredText : expiryText} ${
                        cardExpirationMonth || expiryMonth
                      }/${String(cardExpirationYear || expiryYear)?.substr(2)}`}
                    </span>
                    {subscriptionContainer.ccExpiryFlag && (
                      <CreditCardExpiryInfo
                        isCardExpired={this.isCardExpired}
                        isCardExpiringSoon={this.isCardExpiringSoon}
                        cardType={type}
                      />
                    )}
                    <br />
                    {isFromModal && (
                      <div className="subscription-card-button-wrapper">
                        <div className="subscription-card-button-wrapper">
                          <span>
                            <Button
                              variant="link"
                              className="subscription-card-link-btn p-0"
                              data-testid="qa-subscription-edit-payment"
                              onClick={e => {
                                this.toggleEditPaymentModal(payment?.id)
                              }}
                              cardId={payment?.id}>
                              {this.isCardExpired
                                ? i18nTranslate('catalog.Update', 'Update', {
                                    nameSpace: 'ssr-resource',
                                  })
                                : i18nTranslate('edit', 'Edit')}
                            </Button>
                          </span>
                          <span>
                            <Button
                              variant="link"
                              className="subscription-card-link-btn p-0"
                              data-testid="qa-subscription-delete-payment"
                              onClick={e => {
                                this.toggleDeleteConfirmationModal(payment?.id)
                              }}
                              cardId={payment?.id}>
                              {i18nTranslate('cart.delete', 'Delete')}
                            </Button>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )
              )}
            </>
          ) : (
            ''
          )}
        </Col>
      </>
    )
  }
  handlePaymentSuggestionContinue = async (data, isFromModal) => {
    this.disablePaymentEdit = true
    this.isPaymentCallInProgress = true
    const { id } = data
    overlayState.toggleLoader()
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      {
        paymentId: id,
      }
    )
    this.isEditPayments = false
    this.enablePaymentModal = false
    if (subscriptionContainer.isSuccessResponse(response)) {
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription())
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.paymentMethod',
          'Your payment method has been updated.'
        ),
        true
      )
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
    this.disablePaymentEdit = false
    this.isPaymentCallInProgress = false
  }

  renderPaymentEditView = () => {
    return (
      <ShippingEditingModal
        toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
        isSubscriptionPaymentEditButtonClicked={this.isEditPayments}
        renderTabs={true}
        recommendations={customerContainer.paymentsForDashboard || {}}
        totalPagesLength={this.totalPagesLength}
        customModalTitle={`${i18nTranslate(
          'subscription.paymentTitle',
          'Payment Method'
        )}`}
        isForPaymentMethod={true}
        selectedId={this.subscriptionPaymentId}
        toggleSuggestionView={() => {
          this.isEditPayments = false
          subscriptionContainer.showEditPaymentFromModal = false
        }}
        renderShippingAddressComponent={(payment, isFromModal) => {
          if (
            !addressContainer.isShippingAddressSameAsBillingAddress &&
            addressContainer.isShippingAddressSameAsBillingAddress != undefined
          ) {
            return this.renderShippingAddress(payment, isFromModal)
          } else {
            const paymentProperties = payment?.properties || {}
            const paymentInfo = toJS(payment?.accountInfo || {})
            paymentInfo.properties = paymentProperties
            paymentInfo.type = paymentInfo.type || payment?.type
            paymentInfo.displayName = payment?.name
            return this.renderPaymentMethod(paymentInfo, isFromModal, false)
          }
        }}
        ref={this.shippingEditingModalRef}
        handleAddressContinue={this.handlePaymentSuggestionContinue}
        updateSubscription={this.props.updateSubscription}
        toggleEditPaymentModal={this.toggleEditPaymentModal}
      />
    )
  }

  handleDeletePaymentMethod = cardData => {
    const cardNumber = cardData?.accountInfo?.cardNumber || ''
    const cardProvider = cardData?.accountInfo?.provider || ''

    return (
      <div>
        <div className="delete-msg-wrapper">
          <span>
            {i18nTranslate('payment.deleteMessageStart', 'Delete')}&nbsp;
          </span>
          <span>{capitalizeFirstLetter(cardProvider)} &nbsp;</span>
          <span>****{cardNumber}&nbsp;</span>
          <span>
            {i18nTranslate(
              'payment.deleteMessageEnd',
              'from your saved payments?'
            )}
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-outline-primary cancel-btn"
            onKeyPress={this.toggleDeleteConfirmationModal}
            onClick={this.toggleDeleteConfirmationModal}>
            Cancel
          </button>
          <button
            className="btn btn-primary confirm-btn"
            onKeyPress={() => {
              this.handleDeletePayment()
            }}
            onClick={() => {
              this.handleDeletePayment()
            }}>
            Confirm
          </button>
        </div>
      </div>
    )
  }
  handleDeletePayment = async () => {
    let selectedCardDetails = {
      ...this.selectedCardData,
      ...this.currentPageDetails,
    }
    await customerContainer.deletePayment(selectedCardDetails)
    this.toggleDeleteConfirmationModal()
    const month = this.props?.location?.queryParams?.month || ''
    await subscriptionContainer?.getAllSubscriptionsPreference(
      customerContainer?.userId,
      '',
      true
    )
  }

  isDisablePaymentModal = () => {
    this.enablePaymentModal = false
    this.isEditPayments = false
  }

  render() {
    return (
      <div className="details-section">
        {this.renderPaymentDetails()}
        {this.isEditPayments && this.renderPaymentEditView()}
        {this.showEditPaymentModal && (
          <EditUpdatePaymentModal
            show={this.showEditPaymentModal}
            closeButton={this.toggleEditPaymentModal}
            billingAddressType="subscription"
            IDofCardToBeEdited={this.IDofCardToBeEdited}
            cardDetails={this.selectedCardData}
            isFromCheckout={false}
            isFromSubscription={true}
            closeModalCallback={() => {
              this.showEditPaymentModal = false
            }}
            handlePaymentSuggestionContinue={
              this.handlePaymentSuggestionContinue
            }
            selectedDefaultCardId={this.selectedDefaultCardId}
            isDisablePaymentModal={this.isDisablePaymentModal}
          />
        )}
        {this.showDeleteConfirmationModal && (
          <div>
            <Modal
              className={`visible modal-wrapper p-0`}
              show={this.showDeleteConfirmationModal}
              onHide={() => (this.showDeleteConfirmationModal = false)}
              centered
              animation={false}>
              <Modal.Header
                closeButton={this.toggleDeleteConfirmationModal}
                className={'border-bottom-0'}>
                <Modal.Title className="title-Payment-Modal">
                  {i18nTranslate(
                    'checkout.deletePayment',
                    'Delete payment method'
                  )}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.handleDeletePaymentMethod(this.selectedCardData)}
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    )
  }
}
export default ShippingPayment
export { ShippingPayment }
